import type { Testimonial } from '../testimonials'

export const added: Testimonial = {
  company: 'Akçansa',
  logo: { name: 'Akçansa', src: '/logo/akcansacard.png' },
  portrait: { src: '/photo/portrait-aydin-sener.png', alt: 'Aydın Şener' },
  quote: [
    'Using Digitopia’s tools has been incredibly valuable for us. DMI and Impact Platform '
    + 'helped us achieve a clear, structured roadmap for digital transformation. By engaging '
    + 'cross-functional teams from HR, sales, and IT, we aligned on priorities, sparked '
    + 'company-wide awareness, and identified key projects to drive change effectively.',
  ],
  attribution: 'Aydın Şener, Digital Transformation and Industry 4.0 Manager',
  story: 'akcansa',
}

/** Its place on the wall — the order the live page lists them in. */
export const order = 3
